/// <amd-module name="Build/Admin/PoolsList/Sources/PoolCreationSource" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

import { ElasticPool, ElasticPoolCreationResult } from "DistributedTask/Client/Contracts/TaskAgent";
import { getElasticClient, IElasticRestClient } from "DistributedTask/Client/RestClient/Elastic";

import { TaskAgentPoolCreationData, PoolType } from "Build/Admin/Common/Client/Contracts/DistributedTask/DataProvider";
import { DataProviders } from "Build/Admin/Common/Constants";

export class PoolCreationSource {
    private _client: IElasticRestClient;
    private _pageContext: IVssPageContext;
    private _poolCreationData: TaskAgentPoolCreationData | undefined;
    private _poolCreationDataInitialized: boolean;

    constructor(pageContext: IVssPageContext) {
        this._pageContext = pageContext;
        this._client = getElasticClient(pageContext);
    }

    public getCachedAvailablePoolTypes(): PoolType[] {
        this._initializePoolCreationData();
        if (this._poolCreationData && this._poolCreationData.availablePoolTypes) {
            return this._poolCreationData.availablePoolTypes;
        }
        else {
            // Private pools are always available
            return [PoolType.Private];
        }
    }

    private _initializePoolCreationData(): void {
        if (!this._poolCreationDataInitialized) {
            const contributionService: IVssContributionService = this._pageContext.getService<IVssContributionService>("IVssContributionService");
            this._poolCreationData = contributionService.getData<TaskAgentPoolCreationData>(DataProviders.AgentPoolCreation);
            this._poolCreationDataInitialized = true;
        }
    }

    public async addElasticPool(elasticPool: ElasticPool, poolName: string, authorizeAllPipelines: boolean | undefined, autoProvisionProjectPools: boolean, projectId: string | undefined): Promise<ElasticPoolCreationResult> {
        return this._client.createElasticPool(elasticPool, poolName, authorizeAllPipelines, autoProvisionProjectPools, projectId);
    }
}
